import React from 'react';
import { TextField, MenuItem, Box } from '@mui/material';

/**
 * FormDropdown - Reusable dropdown component with native floating label animations
 * and a safe "No option" fallback for empty lists.
 */
const FormDropdown = React.forwardRef((props, ref) => {
  const {
    name,
    label,
    value = '',
    options = [],
    onChange,
    onBlur,
    required = false,
    disabled = false,
    error = false,
    helperText = '',
    variant = 'outlined',
    size = 'medium',
    className,
    sx = {},
    ...rest
  } = props;

  return (
    <Box className={className} sx={{ width: '100%', mt: 1, ...sx }}>
      <TextField
        select
        inputRef={ref}
        name={name}
        
        // The label natively sits in the middle and floats up when clicked
        label={label}
        value={value}
        
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        error={error}
        helperText={helperText}
        variant={variant}
        size={size}
        fullWidth
        SelectProps={{
          ...rest
        }}
      >
        {/* If the API returned no data, show "No option" inside the menu safely */}
        {options.length === 0 ? [
          // 1. Hidden item: Keeps the box empty so the label can animate down perfectly
          <MenuItem key="empty-match" value="" sx={{ display: 'none' }} />,
          
          // 2. Visible item: Shows "No option" when the user actually opens the dropdown
          <MenuItem key="no-options-text" value="dummy-no-options" disabled>
            No option
          </MenuItem>
        ] : (
          /* If we have data, map the normal options */
          options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={option.disabled || false}
            >
              {option.label}
            </MenuItem>
          ))
        )}
      </TextField>
    </Box>
  );
});

FormDropdown.displayName = 'FormDropdown';

export default FormDropdown;